import ENV from "@/utils/env";
import { createAuthState, normalizeReturnTo } from "@/features/auth/utils/auth-state";
import { AuthLoader } from "@/features/auth/components/auth-loader";
import { useEffect } from "react";

/**
 * buildAuth0AuthorizeUrl function
 *
 * Builds the Auth0 authorization URL for the redirect-based sign-in flow.
 *
 * @param returnTo - Optional return target to restore after authentication.
 * @returns The full Auth0 authorize URL.
 */
export const buildAuth0AuthorizeUrl = (returnTo: string | null) => {
  const params = new URLSearchParams({
    response_type: "code",
    client_id: ENV.AUTH0_CLIENT_ID,
    redirect_uri: ENV.AUTH0_CALLBACK_URL,
    scope: "openid profile email",
    state: createAuthState(returnTo),
  });

  return `${ENV.AUTH0_DOMAIN}/authorize?${params.toString()}`;
};

/**
 * SignInRoute component
 *
 * Performs a full-page redirect to the Auth0 authorization endpoint.
 */
export const SignInRoute = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const returnTo = normalizeReturnTo(urlParams.get("returnTo"));

    // Redirect to Auth0 for login
    window.location.replace(buildAuth0AuthorizeUrl(returnTo));
  }, []);

  return <AuthLoader />;
};
